import { useState } from 'react';
import { useMutation, gql } from '@apollo/client';
import { useFeedback } from '../feedback/Service';
import ReactCodeInput from 'react-verification-code-input';
import { parseGraphQLError } from '../../utils';
import Button from '@mui/joy/Button';
// import Checkbox from '@mui/joy/Checkbox';
import JoyLink from '@mui/joy/Link';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import { Grid, Stack, useTheme } from '@mui/joy';
import useUser from './useUser';
import { AUTH_TOKEN_NAME } from '../../constants';
import { googleLogout } from '@react-oauth/google';

const CONFIRM_EMAIL = gql`
  mutation confirmEmail($code: String!) {
    confirmEmail(code: $code)
  }
`;

const RESTORE_EMAIL_CONFIRMATION = gql`
  mutation resetEmailConfirmation {
    resetEmailConfirmation
  }
`;

export default function ConfirmEmail({ userId }) {
  const theme = useTheme();
  const [confirmEmail, { loading }] = useMutation(CONFIRM_EMAIL, {
    update(cache, { data: { confirmEmail } }) {
      console.log("confirmEmail result", confirmEmail, userId);
      cache.modify({
        id: cache.identify({ _id: userId, __typename: "User" }),
        fields: {
          emailConfirmed: () => confirmEmail,
        }
      });
    }
  });
  const { user, refetch: getUser, loading: userLoading } = useUser({ notifyOnNetworkStatusChange: true });
  const [resetEmailConfirmationCode, { loading: sending }] = useMutation(RESTORE_EMAIL_CONFIRMATION);
  const [code, setCode] = useState("");
  const feedback = useFeedback();

  const handleSubmit = async event => {
    event.preventDefault();
    try {
      await confirmEmail(({ variables: { code } }));
      const tagPrefix = window.location.pathname.startsWith("/company") ? "talent_" : "client_";
      window.gtag('event', tagPrefix + 'confirm_email', {});
      feedback.snackbar({ text: "Email confirmed", type: "success" });
      // Clear stored signup data on successful confirmation
      sessionStorage.removeItem('signup_prefill');
      sessionStorage.removeItem('signup_invite_code');
      getUser({ fetchPolicy: 'network-only' });
    } catch (error) {
      console.warn("Email confirmation error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  };

  const handleResend = async e => {
    e.preventDefault();
    try {
      await resetEmailConfirmationCode();
      feedback.snackbar({ text: "New code was sent to your email", type: "info" });
    } catch (error) {
      console.error("Code resend error", error);
      feedback.snackbar({ text: parseGraphQLError(error), type: "error" });
    }
  }

  const handleCancel = () => {
    // Preserve user data for re-signup
    const prefillData = {
      firstName: user?.firstName || '',
      lastName: user?.lastName || '',
    };
    sessionStorage.setItem('signup_prefill', JSON.stringify(prefillData));
    
    localStorage.setItem(AUTH_TOKEN_NAME, "");
    googleLogout();
    window.location.reload();
  }

  return (
    <Box
      component="main"
      sx={{
        my: 'auto',
        py: 2,
        pb: 5,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: 400,
        maxWidth: '100%',
        mx: 'auto',
        borderRadius: 'sm',
        textAlign: 'center',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        // '& form': {
        //   display: 'flex',
        //   flexDirection: 'column',
        //   gap: 2,
        // },
        // [`& .MuiFormLabel-asterisk`]: {
        //   visibility: 'hidden',
        // },
      }}
    >
      <Stack sx={{ gap: 4, mb: 2 }}>
        <Stack sx={{ gap: 1 }}>
          <Typography component="h1" level="h3">
            Confirm Email
          </Typography>
          <Typography level="body-sm">
            Confirmation code was sent to your email
          </Typography>
        </Stack>
      </Stack>
      <Stack sx={{ gap: 4, mt: 0 }}>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{
          "& input": {
            fontFamily: 'var(--joy-fontFamily-body, "Inter", var(--joy-fontFamily-fallback, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"))',
          },
          "& input:focus": {
            borderColor: theme.vars.palette.primary[500],
          },
        }}>
          <ReactCodeInput value={code} onChange={setCode} type="number" fields={4} autoFocus />
          <Button type="submit" fullWidth sx={{ mt: 4, mb: 1 }} loading={loading || userLoading}>
            Submit
          </Button>
          <Button variant="outlined" color="neutral" fullWidth sx={{ mb: 1 }} onClick={handleCancel}>
            Change Email
          </Button>
          <Grid container>
            <Grid xs>
              <JoyLink href="#" onClick={handleResend} disabled={sending} sx={{ fontSize: 'sm', textAlign: 'center' }}>
                Send new code
              </JoyLink>
            </Grid>
          </Grid>
        </Box>
      </Stack>
    </Box>
  );
}